import { IEvent } from "@quest/adapter-interface";
import {
  Container,
  ingenuity,
} from "@quest/base-core";
import { TopBarView } from "@quest/murka-games-behavior-panther/dist/Game/TopBar/TopBarView";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class TopBarViewGame extends TopBarView {
  protected topbarleftContainer: Container;
  protected topbarFullScreenCont: Container;
  protected topbarSoundCont: Container;
  constructor(json: any) {
    super(json);
    this.hideFullScreenButton();
  }
  /**
   * This method will initialize this class UI elements
   */
  protected initializeElement(): void {
    super.initializeElement();
    this.topbarleftContainer = this.getContainerByID("topbarleftContainer") as Container;
    this.topbarFullScreenCont = this.getContainerByID("topbarFullScreenCont") as Container;
    this.topbarSoundCont = this.getContainerByID("topbarSoundCont") as Container;
  }
  /**
   * to make full screen button configurable
   */
  protected hideFullScreenButton(): void {
    if (!ingenuity.configData.showFullScreen) {
      this.topbarFullScreenCont.visible = false
    }
  }
  public resize(evt: IEvent): void {
    super.resize(evt);
    if (!(ingenuity.parserModel as GameParserModel).getIsLobbyActive()) {
      this.topbarleftContainer && (this.topbarleftContainer.x = this.topbarleftContainer.json.nonHomePosX);
    }
    if (!SlotConstantsBehavior.SHOW_GAME_CLOCK) {
      this.topbarSoundCont && (this.topbarSoundCont.x = this.topbarSoundCont.json.ontarioX)
      this.topbarFullScreenCont && (this.topbarFullScreenCont.x = this.topbarFullScreenCont.json.orientation[ingenuity.deviceEnv.getOrientation()].ontarioX)
    }
  }
}
